
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { ForbiddenPage } from '@/components/Pages/Errors/ForbiddenPage';
import type { IThemePageProps } from '@/components/Pages/Themes/ThemePage';
import { ThemesViewPage } from '@/components/Pages/Themes/ThemePage';
import { getAnalyticsData, getBaseAnalytics } from '@/components/Templates/InfiniteScrollPage/InfiniteScrollPage';
import { BaseAppContextContainer } from '@/contexts/AppContext/AppContextContainer';
import { getAppContextServerSideProps } from '@/contexts/AppContext/AppContextServer';
import { ContentType } from '@/interfaces';
import { getPublicMetadataForTerminalContent } from '@/services/TerminalContent';
import { logger } from '@/utils/logger/logger';
import { correlationHeader } from '@/utils/siteUtils';
const getServerSideProps = getAppContextServerSideProps(async ({ query, req, res, api }) => {
    const apiQuery: any = {};
    const storyLanguage = query?.language?.toString();
    if (storyLanguage) {
        apiQuery.translationLanguageTarget = storyLanguage.toLowerCase();
    }
    try {
        const data = await api.get({
            path: '/themes/[ID]',
            replacements: { id: query.id as string },
            query: apiQuery,
        });
        if (data?.canonicalResource) {
            let url = data.canonicalResource.url;
            if (storyLanguage) {
                url += `?language=${storyLanguage}`;
            }
            return { redirect: { destination: url, statusCode: 301 } };
        }
        if (data?.theme) {
            api.post({
                path: '/users/content_view',
                body: { contentId: data.theme.id, contentType: ContentType.theme },
            }).catch(() => { });
            return {
                props: {
                    analyticsMetadata: getAnalyticsData(ContentType.theme, data.theme.id),
                    ...data,
                },
            };
        }
    }
    catch (e) {
        const acceptableHttpErrors = [403];
        if (e.hasOwnProperty('response') && e.response && acceptableHttpErrors.includes(e.response.status)) {
            res.statusCode = e.response.status;
            return {
                props: { analyticsMetadata: getBaseAnalytics(ContentType.theme), responseCode: e.response.status },
            };
        }
        const context = {
            correlationId: req?.headers?.[correlationHeader],
            referrer: req?.headers?.referer,
        };
        logger.error('Error fetching theme data: ', { e, ...context });
        throw e;
    }
    return { notFound: true };
}, getPublicMetadataForTerminalContent);
export default class extends BaseAppContextContainer<IThemePageProps & {
    responseCode?: number;
}> {
    public render() {
        if (this.props?.responseCode === 403) {
            return <ForbiddenPage />;
        }
        return (<ThemesViewPage theme={this.props.theme} relatedThemes={this.props.relatedThemes} translationLocales={this.props.translationLocales}/>);
    }
}

    async function __Next_Translate__getServerSideProps__1a1a756c942__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/themes/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a756c942__ as getServerSideProps }
  